import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import BrieConversationAPI from "../../../api/api/BrieConversationAPI";

const empty: [] = [];

export interface BrieGPTModel {
  ModelName: string;
  ModelAPIName: string;
  Company: string;
  Description: string;
  Status: "Available" | "Unavailable" | "Degraded";
  InputTokenCost: number;
  OutputTokenCost: number;
  GCModel?: boolean;
}

// Model and setModel are provided, to update the model in case the selected model is no longer available.
export default function useBrieGPTModels({
  model,
  setModel,
}: {
  model: string;
  setModel: (newModel: string) => void;
}) {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const tenantID = useAtomValue(tenantIDAtom);

  const models = useQuery({
    queryKey: ["BrieGPTModels", tenantID],
    queryFn: () =>
      BrieConversationAPI.getBrieGPTModels().then((res) => {
        const models = (res?.data?.data?.models || empty) as BrieGPTModel[];

        // Ensure the model the user has selected is available.
        if (!models.find((m: BrieGPTModel) => m.ModelAPIName === model)) {
          if (models.length > 0) {
            setModel(models[0]?.ModelAPIName);
          }
        }

        return (res?.data?.data?.models || empty) as BrieGPTModel[];
      }),
    enabled: queriesEnabled,
  });

  return {
    models: models.data || empty,
    modelsLoading: models.isLoading,
  };
}
